/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getSubscriptionsRpc = {
  serviceName: 'com.hubspot.esp.sync.rpc.FormSubscriptionsRpc',
  rpcName: 'getSubscriptions',
  auth: 'app',
  fingerprint: 'lWDblRo20TdXcmgNnwoNaEuCAHH-E4Og',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSubscriptionStatusRpc = {
  serviceName: 'com.hubspot.esp.sync.rpc.FormSubscriptionsRpc',
  rpcName: 'getSubscriptionStatus',
  auth: 'app',
  fingerprint: 'lWDblRo20TdFL2koN_HRY0uCAHH-E4Og',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBatchStatusesRpc = {
  serviceName: 'com.hubspot.esp.sync.rpc.FormSubscriptionsRpc',
  rpcName: 'getBatchStatuses',
  auth: 'app',
  fingerprint: 'cJjMkyDK6zlYfxADSdHu20uCAHH-E4Og',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkUpdateSubscriptionsRpc = {
  serviceName: 'com.hubspot.esp.sync.rpc.FormSubscriptionsRpc',
  rpcName: 'bulkUpdateSubscriptions',
  auth: 'app',
  fingerprint: 'LcV1GkiA0PgtxXUaSIDQ-EuCAHH-E4Og',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createSubscriptionRpc = {
  serviceName: 'com.hubspot.esp.sync.rpc.FormSubscriptionsRpc',
  rpcName: 'createSubscription',
  auth: 'app',
  fingerprint: 'ejix--_RDLOOUe2e_r4XmUuCAHH-E4Og',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};